import { useContext } from 'react';
import { default as AnalyticsReactContext } from '@atlaskit/analytics-next-stable-react-context';
export const useAnalyticsContext = () => {
  return useContext(AnalyticsReactContext);
};